var baseUrl = 'https://jsonplaceholder.typicode.com/';

const configVariables = {
    baseUrl,
};

const constantVariables = {
    TempUser: {
        name: 'David Smith',
        email: 'david@yopmail.com',
        pass: 'asd123',
        userId: 12,
    },
    dateFormat: 'MM/DD/YYYY',
    timeFormat: 'hh:mm A',
};

export const workforceManagementStaticPaths = [
    '/workforce-management',
    '/workforce-management/shift-scheduler',
    '/workforce-management/time-of-request',
    '/workforce-management/drop-swap-requests',
    '/workforce-management/my-shifts',
];

export const securityIssuesStaticPaths = [
    '/security-issues',
    '/security-issues/manage-incidents',
    '/security-issues/report',
];

export const shiftBreaks = [
    {
        value: '0',
        label: '0',
    },
    {
        value: '30',
        label: '30',
    },
    {
        value: '40',
        label: '40',
    },
    {
        value: '50',
        label: '50',
    },
    {
        value: '60',
        label: '60',
    },
];

export const recurringFrequency = [
    {
        value: 'daily',
        label: 'Daily',
    },
    {
        value: 'weekly',
        label: 'Weekly',
    },
    {
        value: 'biweekly',
        label: 'Biweekly',
    },
    {
        value: 'monthly',
        label: 'Monthly',
    },
    // {
    //     value: 'yearly',
    //     label: 'Yearly',
    // },
];

export const minSize = 1 * 1024; // 1 KB in bytes
export const maxSize = 6 * 1024 * 1024; // 6 MB in bytes

export default {
    ...configVariables,
    ...constantVariables,
};
